import type { SearchDTO } from "../types";

// Filter out null, undefined, empty string, and 0 values from the params object
export const getDefinedParams = (params: Partial<SearchDTO> | Record<string, string | number | null | boolean>) => {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => {
            return value !== null && value !== undefined && Number(value) !== 0 && value !== "" && value !== false && value !== "false";
        }),
    ) as Partial<SearchDTO>;
};
